import { render } from "./HomePageDonuts.vue?vue&type=template&id=74f619ab&scoped=true"
import script from "./HomePageDonuts.vue?vue&type=script&lang=js"
export * from "./HomePageDonuts.vue?vue&type=script&lang=js"

import "./HomePageDonuts.vue?vue&type=style&index=0&id=74f619ab&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f619ab"]])

export default __exports__